import { fitText as fitTextFct } from "@/lib/fit-text";

export const fitText = {
  mounted(el: any, binding: any) {
    fitTextFct(el, {
      minSize: binding.value?.minSize ?? 10,
      maxSize: binding.value?.maxSize ?? 512,
      unit: binding.value?.unit ?? "px",
      compressor: binding.value?.compressor ?? 1
    });
  },
};
